export default __webpack_public_path__ + "static/media/definer.f2dd94ca.jpg";